module.exports = __webpack_public_path__ + "static/media/3_ic_irtotavara_a.3eabedd9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/map/images/3_ic_irtotavara_a.svg
// module id = 1181
// module chunks = 0